import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import type { ComponentProps } from "react";

interface TFormInputProps extends ComponentProps<any> {
  name: string;
  control: any;
  label?: string;
  displayError?: boolean;
  inputProps?: any;
  autofocus?: boolean;
  defaultValue?: string | number;
  placeholder?: any;
  required?: boolean;
  type?: string;
}

export const FormInputText = ({
  name,
  label,
  control,
  placeholder,
  displayError = true,
  inputProps,
  autofocus = false,
  required = false,
  defaultValue = "",
  type = "text", // Default to text but allow numbers
  ...rest
}: TFormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={type === "number" ? Number(defaultValue) : defaultValue} // Ensure the default value is a number if type is number
      render={({ field: { onChange, ...field }, fieldState: { error } }) => (
        <>
          <TextField
            fullWidth
            helperText={error && displayError ? error.message : null}
            error={displayError && !!error}
            autoComplete="off"
            autoFocus={autofocus}
            placeholder={placeholder}
            label={label}
            required={required}
            type={type} // Pass the type prop to ensure "number" works
            {...field}
            {...rest}
            InputProps={{
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                const value =
                  type === "number"
                    ? parseFloat(e.target.value)
                    : e.target.value; // Convert to number if type is number
                onChange(value);
              },
              ...inputProps,
            }}
          />
        </>
      )}
    />
  );
};
